export default __webpack_public_path__ + "static/media/experience-bg-image.9ae91dfb.jpg";